import React from 'react'
import { View } from 'react-native'
import { StyleService, useStyleSheet } from '@src/style/service'
import { ContentLoader, Rect } from '@src/components/ContentLoader'

export const ProgramCardContentLoader = () => {
  const styles = useStyleSheet(themedStyles)

  return (
    <View style={styles.container}>
      <ContentLoader variant="card" style={styles.loader}>
        <Rect x="0" y="3" width="38%" height="20" rx="6" ry="6" />
        <Rect x="87%" y="3" width="13%" height="20" rx="6" ry="6" />
        <Rect x="0" y="29" width="50%" height="18" rx="6" ry="6" />

        <Rect x="0" y="61" width="80%" height="16" rx="6" ry="6" />
        <Rect x="0" y="83" width="64%" height="16" rx="6" ry="6" />

        <Rect x="0" y="130" width="36%" height="18" rx="6" ry="6" />
      </ContentLoader>
    </View>
  )
}

const themedStyles = StyleService.create({
  container: {
    width: '100%',
    padding: 16,
    borderRadius: 16,
    borderWidth: 1,
    borderColor: 'theme.surface.base',
    gap: 10,
  },
  loader: {
    height: 165,
  },
})
